import script from "./PreRegions.vue?vue&type=script&setup=true&lang=js"
export * from "./PreRegions.vue?vue&type=script&setup=true&lang=js"

import "./PreRegions.vue?vue&type=style&index=0&id=1bb1fd31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb1fd31"]])

export default __exports__